import { Upload, UploadProps } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { ComponentType } from 'react';
import { styled } from 'styled-components';

export const StyledUploadFile = styled(
    Upload as ComponentType<any>
)<UploadProps>`
    .ant-upload-wrapper
        .ant-upload-list
        .ant-upload-list-item-error
        .ant-upload-list-item-name {
        color: var(--color-text);
    }
`;

export const StyledDragger = styled(Upload.Dragger as ComponentType<any>)`
    .ant-upload-drag {
        border-radius: 12px;
        border: 2px dashed var(--color-divider);
        padding: 24px;
    }

    .ant-upload .ant-upload-btn {
        padding: 0;
    }
`;

export const StyledUploadFileIcon = styled.button`
    background-color: transparent;
    border-radius: 4px;
    border: 1px solid var(--color-divider);
    padding: 8px;
    display: flex;

    align-items: center;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    margin-left: 8px;
    &:hover {
        border-color: var(--color-divider);
    }
    &:hover svg {
        color: var(--color-divider);
    }
`;

export const StyledFormItem = styled(FormItem as ComponentType<any>)`
    .ant-form-item-required::before {
        display: none !important;
        visibility: hidden !important;
        margin-inline-end: 0 !important;
    }
    .ant-form-item-label > label::after {
        ${(props) =>
            props.required
                ? 'content: "*" !important'
                : 'content: "" !important'};
        position: relative;
        margin-block: 0;
        margin-inline-start: 2px;
        margin-inline-end: 8px;
        color: var(--color-text);
        visibility: visible !important;
    }
`;
